import _defineProperty from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import { animated, useSpring } from '@react-spring/web';
import { useTheme } from 'theming';
import useStyles from './styles';
import clsx from 'clsx';
var defaultAnimation = {
  loop: true,
  from: {
    rotateZ: 0
  },
  to: {
    rotateZ: 360
  },
  config: {
    duration: 750
  }
};

var Spinner = function Spinner(_ref) {
  var _clsx;

  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary' : _ref$color,
      _ref$animationConfig = _ref.animationConfig,
      animationConfig = _ref$animationConfig === void 0 ? {} : _ref$animationConfig,
      _ref$customClassName = _ref.customClassName,
      customClassName = _ref$customClassName === void 0 ? '' : _ref$customClassName,
      _ref$inlineStyles = _ref.inlineStyles,
      inlineStyles = _ref$inlineStyles === void 0 ? {} : _ref$inlineStyles;
  var theme = useTheme();
  var classes = useStyles({
    theme: theme
  });
  var interpolation = useSpring(Object.assign(Object.assign({}, defaultAnimation), animationConfig));
  var containerStyle = clsx((_clsx = {}, _defineProperty(_clsx, classes.container, true), _defineProperty(_clsx, classes[color], Boolean(color)), _defineProperty(_clsx, customClassName, Boolean(customClassName)), _clsx));
  return React.createElement(animated.div, {
    className: containerStyle,
    style: Object.assign(Object.assign({}, inlineStyles), interpolation)
  });
};

export { Spinner };